module.exports = __webpack_public_path__ + "static/media/cover-insurance-fraud-investigation.1a8adbfc.jpg";